import { create } from 'apisauce';
import router from '@/router/index.js';

const apisauce = (token) =>{
    const api = create({
        baseURL: 'https://empa-ba.americatrack.com/api/',
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    api.addResponseTransform((r)=>{
        if(!r.ok){
            if(r.data && r.data.error == "Token invalid"){
                localStorage.removeItem("usrId");
                router.push("/");
            }else if(r.status == 500)
                apisauce(localStorage.getItem("token")).post('endpoint/devices_erros',
                {
                    erro: JSON.stringify(r.data),
                    idusuario: localStorage.getItem("usrId"),
                    idcliente: localStorage.getItem("idcliente"),
                    endpoint: r.config.baseURL
                }).then(r2=>{
                    const erroJSON = JSON.stringify(r.data);
                    if(r2.ok){
                        window.mainApp.erro_id = r2.data[0].iderro;
                        if(erroJSON.mensagem.errors && erroJSON.mensagem.errors[0].message == "rgidcliente must be unique")
                            window.mainApp.erro_msg = "Você inseriu um RG já cadastrado no sistema!";
                        else 
                            window.mainApp.erro_msg = erroJSON.mensagem.name;
                        window.mainApp.erro_dialog = true;
                    }
                });
        } 
    });
    return api;
}; 

export default apisauce;

//devices_erros 
